import { Text } from "@/components/ui/baseUi/text"
import { BoxProgramVisibility } from "@/modules/boxProgrammation/boxProgramTypes"
import { getBoxProgrammationVisibilityName } from "@/modules/boxProgrammation/boxProgramUtils"
import { cn } from "@/modules/lib/utils"
import { BoxProgrammationVisibilityPrivateIcon } from "@images/svgIcons/boxProgrammationVisibilityPrivate"
import { BoxProgrammationVisibilityPublicIcon } from "@images/svgIcons/boxProgrammationVisibilityPublic"
import { BoxProgrammationVisibilityStandardIcon } from "@images/svgIcons/boxProgrammationVisibilityStandard"
import { BoxProgrammationVisibilityVector } from "@images/svgIcons/boxProgrammationVisibilityVector"

export function BoxProgramPrivacyIcon({
  visibility,
  isSelected,
  className,
  ...props
}: React.ComponentProps<"div"> & { visibility: BoxProgramVisibility; isSelected: boolean }) {
  return (
    <div className={cn("flex flex-col items-center gap-2", className)} {...props}>
      <Text fontStyle="TS">{getBoxProgrammationVisibilityName(visibility)}</Text>

      <div className="relative w-max">
        <BoxProgrammationVisibilityVector
          color="currentColor"
          className={cn(isSelected ? "text-primary-400" : "text-textDefault-body")}
        />
        {visibility === BoxProgramVisibility.MEMBERS ? (
          <BoxProgrammationVisibilityStandardIcon
            color="currentColor"
            className="absolute top-1/2 left-1/2 text-textDefault-body"
            style={{ transform: "translate(-50%, -70%)" }}
          />
        ) : visibility === BoxProgramVisibility.PRIVATE ? (
          <BoxProgrammationVisibilityPrivateIcon
            color="currentColor"
            className="absolute top-1/2 left-1/2 text-textDefault-body"
            style={{ transform: "translate(-50%, -70%)" }}
          />
        ) : (
          <BoxProgrammationVisibilityPublicIcon
            color="currentColor"
            className="absolute top-1/2 left-1/2 text-textDefault-body"
            style={{ transform: "translate(-50%, -70%)" }}
          />
        )}
      </div>
    </div>
  )
}
